import { render, staticRenderFns } from "./VerEvaluacionesRiesgos.vue?vue&type=template&id=0fc954a3&"
import script from "./VerEvaluacionesRiesgos.vue?vue&type=script&lang=js&"
export * from "./VerEvaluacionesRiesgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports